export type Lang = 'en' | 'ru';

export const locales: Record<Lang, Record<string, string>> = {
  en: {
    'menu.title': 'Henry Unstoppable',
    'menu.play': '▶ Play',
    'menu.shop': '🛒 Shop',
    'menu.lang': '🌐 RU',
    'menu.coins': '🪙 Coins',
    'game.wave': 'Wave',
    'game.level': 'Level',
    'game.hp': 'HP',
    'game.coins': 'Coins',
    'game.mute.on': '🔊',
    'game.mute.off': '🔇',
    'game.boss_warning': '⚠ BOSS ⚠',
    'game.boss_incoming': '⚠ BOSS INCOMING',
    'upgrade.title': 'Level Up!',
    'upgrade.choose': 'Choose an upgrade:',
    'upgrade.type.weapon': 'WEAPON',
    'upgrade.type.passive': 'PASSIVE',
    'upgrade.type.special': 'SPECIAL',
    'upgrade.owned': 'Owned',
    'upgrade.synergy_unlocked': '✨ Synergy Unlocked!',
    'gameover.title': 'GAME OVER',
    'gameover.wave': 'Wave Reached',
    'gameover.kills': 'Enemies Defeated',
    'gameover.coins': 'Coins Earned',
    'gameover.restart': '🔄 Play Again',
    'gameover.lang': '🌐 Switch language',
    'results.title': '☠ Run Over',
    'results.survived': '⏱ Survived',
    'results.wave': '🌊 Wave reached',
    'results.kills': '💀 Enemies killed',
    'results.coins': '🪙 Coins earned',
    'results.gold': '💰 Gold earned',
    'results.xp': '✨ XP earned',
    'results.levelup': '⬆ LEVEL UP!',
    'results.card_drop': '🎁 Card Drop!',
    'results.play_again': '▶ Play Again',
    'results.lobby': '🏠 Lobby',
    'results.share': '📤 Share Score',
    'results.share_message': '🎮 Henry Unstoppable!\n🌊 Wave {wave} | 💀 {kills} kills | ⏱ {time}\nCan you beat my score?',
    'shop.title': 'Shop',
    'shop.coins': 'Coins',
    'shop.level': 'Level',
    'shop.buy': 'Buy',
    'shop.max': 'MAX',
    'shop.back': 'Back',
    'shop.upgrade.maxHp': 'Max HP',
    'shop.upgrade.startingDamage': 'Starting Damage',
    'shop.upgrade.moveSpeed': 'Move Speed',
    'shop.upgrade.startingLevel': 'Starting Level',
    'card.damage': 'Damage Up',
    'card.speed': 'Speed Up',
    'card.hp': 'HP Up',
    'card.attackSpeed': 'Attack Speed',
    'card.regen': 'Regeneration',
    'card.armor': 'Armor',
    'card.crit': 'Critical Hit',
    'card.magnet': 'Magnet',
    'boss.forest': 'Forest Guardian',
    'boss.cave': 'Cave Lurker',
    'boss.graveyard': 'Graveyard Lich',
    'boss.castle': 'Castle Overlord',
    'rarity.common': 'COMMON',
    'rarity.rare': 'RARE',
    'rarity.epic': 'EPIC',
    'rarity.legendary': 'LEGENDARY',
    'card.fireball.name': 'Fireball',
    'card.fireball.description': '+1 Fireball level (AoE burst)',
    'card.lightning.name': 'Chain Lightning',
    'card.lightning.description': '+1 Lightning level (chains to enemies)',
    'card.orbiting_shield.name': 'Orbiting Shield',
    'card.orbiting_shield.description': '+1 orbiting projectile',
    'card.spin_attack.name': 'Spin Attack',
    'card.spin_attack.description': '+1 Spin Attack level (360° melee)',
    'card.frost_nova.name': 'Frost Nova',
    'card.frost_nova.description': '+1 Frost Nova level (slows + AoE)',
    'card.life_steal.name': 'Life Steal',
    'card.life_steal.description': '+5% of damage dealt restored as HP',
    'card.arrow_rain.name': 'Arrow Rain',
    'card.arrow_rain.description': '+1 Arrow Rain level (volley from sky)',
    'card.hp_up.name': 'HP Up',
    'card.hp_up.description': '+25 max HP (heals 25 too)',
    'card.speed_up.name': 'Speed Up',
    'card.speed_up.description': '+15% movement speed',
    'card.damage_up.name': 'Damage Up',
    'card.damage_up.description': '+20% damage per stack',
    'card.attack_speed.name': 'Attack Speed',
    'card.attack_speed.description': '+20% attacks per second',
    'card.regen.name': 'Regen',
    'card.regen.description': '+2 HP restored per second',
    'card.armor.name': 'Armor',
    'card.armor.description': '+5 flat damage reduction',
    'card.crit.name': 'Crit Chance',
    'card.crit.description': '+10% crit chance (2× damage)',
    'card.magnet.name': 'Magnet',
    'card.magnet.description': '+50% item pickup radius',
    'card.gold_bonus.name': 'Gold Rush',
    'card.gold_bonus.description': '+25% gold from enemies',
    'card.xp_bonus.name': 'Scholar',
    'card.xp_bonus.description': '+20% XP gain',
    'card.level_skip.name': 'Level Skip',
    'card.level_skip.description': '+50% XP gain for the rest of the run',
    'card.extra_life.name': 'Extra Life',
    'card.extra_life.description': 'Revive once with 50% HP on death',
    'card.boss_killer.name': 'Boss Killer',
    'card.boss_killer.description': '+50% damage vs bosses',
  },
  ru: {
    'menu.title': 'Генри Непобедимый',
    'menu.play': '▶ Играть',
    'menu.shop': '🛒 Магазин',
    'menu.lang': '🌐 EN',
    'menu.coins': '🪙 Монеты',
    'game.wave': 'Волна',
    'game.level': 'Уровень',
    'game.hp': 'Здоровье',
    'game.coins': 'Монеты',
    'game.mute.on': '🔊',
    'game.mute.off': '🔇',
    'game.boss_warning': '⚠ БОСС ⚠',
    'game.boss_incoming': '⚠ ПОЯВЛЯЕТСЯ БОСС',
    'upgrade.title': 'Повышение уровня!',
    'upgrade.choose': 'Выберите улучшение:',
    'upgrade.type.weapon': 'ОРУЖИЕ',
    'upgrade.type.passive': 'ПАССИВ',
    'upgrade.type.special': 'ОСОБОЕ',
    'upgrade.owned': 'Есть',
    'upgrade.synergy_unlocked': '✨ Синергия открыта!',
    'gameover.title': 'КОНЕЦ ИГРЫ',
    'gameover.wave': 'Достигнута волна',
    'gameover.kills': 'Врагов побеждено',
    'gameover.coins': 'Монет получено',
    'gameover.restart': '🔄 Играть снова',
    'gameover.lang': '🌐 Сменить язык',
    'results.title': '☠ Забег завершён',
    'results.survived': '⏱ Выжито',
    'results.wave': '🌊 Достигнута волна',
    'results.kills': '💀 Врагов побеждено',
    'results.coins': '🪙 Монет получено',
    'results.gold': '💰 Золота получено',
    'results.xp': '✨ Опыта получено',
    'results.levelup': '⬆ НОВЫЙ УРОВЕНЬ!',
    'results.card_drop': '🎁 Выпала карта!',
    'results.play_again': '▶ Играть снова',
    'results.lobby': '🏠 Лобби',
    'results.share': '📤 Поделиться',
    'results.share_message': '🎮 Генри Непобедимый!\n🌊 Волна {wave} | 💀 {kills} убийств | ⏱ {time}\nСможешь побить мой рекорд?',
    'shop.title': 'Магазин',
    'shop.coins': 'Монеты',
    'shop.level': 'Уровень',
    'shop.buy': 'Купить',
    'shop.max': 'МАКС',
    'shop.back': 'Назад',
    'shop.upgrade.maxHp': 'Макс. здоровье',
    'shop.upgrade.startingDamage': 'Начальный урон',
    'shop.upgrade.moveSpeed': 'Скорость движения',
    'shop.upgrade.startingLevel': 'Начальный уровень',
    'card.damage': 'Урон +',
    'card.speed': 'Скорость +',
    'card.hp': 'Здоровье +',
    'card.attackSpeed': 'Скорость атаки',
    'card.regen': 'Регенерация',
    'card.armor': 'Броня',
    'card.crit': 'Крит. удар',
    'card.magnet': 'Магнит',
    'boss.forest': 'Хранитель леса',
    'boss.cave': 'Пещерный охотник',
    'boss.graveyard': 'Лич кладбища',
    'boss.castle': 'Владыка замка',
    'rarity.common': 'ОБЫЧНАЯ',
    'rarity.rare': 'РЕДКАЯ',
    'rarity.epic': 'ЭПИЧЕСКАЯ',
    'rarity.legendary': 'ЛЕГЕНДАРНАЯ',
    'card.fireball.name': 'Огненный шар',
    'card.fireball.description': '+1 уровень огненного шара (взрыв по площади)',
    'card.lightning.name': 'Цепная молния',
    'card.lightning.description': '+1 уровень молнии (перепрыгивает между врагами)',
    'card.orbiting_shield.name': 'Орбитальный щит',
    'card.orbiting_shield.description': '+1 орбитальный снаряд',
    'card.spin_attack.name': 'Вихревая атака',
    'card.spin_attack.description': '+1 уровень вихря (атака на 360°)',
    'card.frost_nova.name': 'Ледяная нова',
    'card.frost_nova.description': '+1 уровень новы (замедление + урон по площади)',
    'card.life_steal.name': 'Кража жизни',
    'card.life_steal.description': '+5% нанесённого урона лечит HP',
    'card.arrow_rain.name': 'Дождь стрел',
    'card.arrow_rain.description': '+1 уровень дождя стрел',
    'card.hp_up.name': 'Больше HP',
    'card.hp_up.description': '+25 к макс. HP (и лечение на 25)',
    'card.speed_up.name': 'Скорость',
    'card.speed_up.description': '+15% к скорости движения',
    'card.damage_up.name': 'Урон',
    'card.damage_up.description': '+20% урона за стак',
    'card.attack_speed.name': 'Скорость атаки',
    'card.attack_speed.description': '+20% атак в секунду',
    'card.regen.name': 'Регенерация',
    'card.regen.description': '+2 HP в секунду',
    'card.armor.name': 'Броня',
    'card.armor.description': '+5 к снижению входящего урона',
    'card.crit.name': 'Шанс крита',
    'card.crit.description': '+10% шанса крита (2× урон)',
    'card.magnet.name': 'Магнит',
    'card.magnet.description': '+50% к радиусу подбора',
    'card.gold_bonus.name': 'Золотая лихорадка',
    'card.gold_bonus.description': '+25% золота с врагов',
    'card.xp_bonus.name': 'Учёный',
    'card.xp_bonus.description': '+20% опыта',
    'card.level_skip.name': 'Пропуск уровня',
    'card.level_skip.description': '+50% опыта до конца забега',
    'card.extra_life.name': 'Доп. жизнь',
    'card.extra_life.description': 'Один раз воскресает с 50% HP',
    'card.boss_killer.name': 'Убийца боссов',
    'card.boss_killer.description': '+50% урона по боссам',
  },
};
